import { Avatar, Box, TextField, Typography } from '@mui/material'
import { ConfirmWithDialogButton } from 'shared/ui'
import { usePipelineStatus } from './hooks'
import { PipelineStatusProps } from './types'

export function PipelineStatus({ treeId, versionId }: PipelineStatusProps) {
  const { pipelineStatus, error, handleRemovePipeline } = usePipelineStatus(
    treeId,
    versionId,
  )

  return (
    <Box border={1} borderColor="grey.300" borderRadius={1} p={2} mb={2}>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Avatar
          sx={{
            width: 12,
            height: 12,
            bgcolor: error ? 'warning.main' : 'success.main',
          }}
        />
        <Typography variant="h6" sx={{ fontStyle: 'italic' }}>
          Pipeline
        </Typography>
      </Box>

      {error && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="error">
            Error: {error}
          </Typography>
        </Box>
      )}

      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <TextField
          value={pipelineStatus}
          placeholder="Pipeline status will appear here..."
          multiline
          rows={2}
          variant="outlined"
          size="small"
          label="Status"
          sx={{ flexGrow: 1 }}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <ConfirmWithDialogButton
          variant="outlined"
          color="error"
          dialogTitle="Reset Pipeline"
          dialogContent={
            <Typography>
              Are you sure you want to reset the asset upload pipeline? Existing
              upload results will be removed.
            </Typography>
          }
          onClick={handleRemovePipeline}
          cta="Reset"
          cancel="Cancel"
        >
          Reset Pipeline
        </ConfirmWithDialogButton>
      </Box>
    </Box>
  )
}
